import React from "react";
import { Link } from "react-router-dom";
import SideBarNav from "./SideBarNav";
import { getAllOrders } from "../../modules/actions/orderActions";
import { addFlashMessage } from "../../modules/actions/flashMessages.js";
import { connect } from "react-redux";
import moment from "moment";
import PropTypes from "prop-types";
class OrderHistory extends React.Component {
  componentDidMount() {
    this.props.getAllOrders();
  }
  render() {
    console.log("order history", this.props);
    const { orderslist } = this.props;
    console.log("orderslist", orderslist);
    return (
      <section className="BodyContainer">
        <div className="container">
          <div className="row">
            <SideBarNav />

            <div className="col-lg-8 order-history">
              <div className="mt-0">
                <h4 className="features_title">Order History</h4>

                <div style={{ clear: "both", height: "15px" }} />

                <div className="table-responsive orders-list">
                  <table className="table">
                    <thead>
                      <tr>
                        <th>ORDER #</th>
                        <th>date</th>
                        <th>ship to</th>
                        <th>order total</th>
                        <th>ORDER STATUS</th>
                        <th />
                      </tr>
                    </thead>
                    <tbody>
                      {orderslist.map(function(order, index) {
                        const transaction = order.paypal.transactions[0].amount;
                        const shipto = order.type === 'device_recharge' ? order.billing.firstname + " " + order.billing.lastname : (order.shipping ? order.shipping.firstname + " " + order.shipping.lastname : order.billing.firstname + " " + order.billing.lastname);
                        return (
                          <tr key={index}>
                            <td>{order.orderId}</td>
                            <td>
                              {moment(order.orderDate).format("MM/DD/YYYY")}
                            </td>
                            <td>
                              {shipto}
                            </td>
                            <td>${transaction.total}</td>
                            <td>Complete</td>
                            <td>
                              <Link to={`/dashboard/order/${order.orderId}`}>
                                View order
                              </Link>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}
OrderHistory.contextTypes = {
  router: PropTypes.object.isRequired
};

function mapStateToProps(state) {
  return {
    orderslist: state.order.orderslist
  };
}

export default connect(
  mapStateToProps,
  { getAllOrders, addFlashMessage }
)(OrderHistory);



// WEBPACK FOOTER //
// ./src/pages/dashboard/OrderHistory.js